//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ScheduleSessionCard from './ScheduleSessionCard.vue';
import { formatTime } from './scheduleTimeUtils.js';
import { isNonSessionItem } from './scheduleResultGrouping.js';

export default {
  name: 'ConcurrentSessionGroup',

  components: {
    ScheduleSessionCard,
  },

  props: {
    sessions: {
      type: Array,
      required: true,
    },
    startTime: {
      type: String,
      required: true,
    },
    showDate: {
      type: Boolean,
      default: false,
    },
    filterResetKey: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      expanded: false,
      atBottom: false,
      isOverflowing: false,
    };
  },

  watch: {
    expanded(val) {
      if (val) {
        this.$nextTick(() => {
          const el = this.$refs.cards;
          if (!el) return;
          this.checkAtBottom();
          this._resizeObserver = new ResizeObserver(() => this.checkAtBottom());
          this._resizeObserver.observe(el);
        });
      } else {
        this._resizeObserver?.disconnect();
        this._resizeObserver = null;
        this.isOverflowing = false;
        this.atBottom = false;
      }
    },
    filterResetKey: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.expanded = true;
        }
      },
    },
  },

  computed: {
    isConcurrent() {
      const regularSessions = this.sessions.filter(s =>
        !isNonSessionItem((s.meta && s.meta.sessionType) || '')
      );
      return regularSessions.length > 1;
    },
  },

  beforeDestroy() {
    this._resizeObserver?.disconnect();
  },

  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },

    onCardsScroll() {
      this.checkAtBottom();
    },

    checkAtBottom() {
      const el = this.$refs.cards;
      if (!el) return;
      const scrollbarWidth = el.offsetWidth - el.clientWidth;
      this.$refs.cardsWrap.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
      this.isOverflowing = el.scrollHeight > el.clientHeight;
      this.atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
    },

    cardMode(session) {
      if (isNonSessionItem((session.meta && session.meta.sessionType) || '')) {
        return (session.summary || '').trim() ? 'expanded' : 'simple';
      }
      return 'expanded';
    },

    formatTime,
  },
};
